import React from "react";
import { useState, useEffect, useContext } from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { Drawer } from "@material-ui/core";
import { makeStyles, ThemeProvider } from "@material-ui/core/styles";
import TurnosLista from "./TurnosLista";
import TurnosForm from "./TurnosForm";
import { PERMISOS } from "helpers/PermisosConfig";
import Permission from "helpers/Permission";
import { Link } from "react-router-dom";
import { errorBackendMsg, getPermisoDefinicion } from "helpers/helpers";
import { useHistory } from "react-router-dom";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
  cardCrear: {
    height: 120,
    width: "100%",
    color: "white",
    fontSize: "1.3rem",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    textTransform: "none",
    "&:hover": {
      backgroundColor: theme.palette.secondary.dark,
      cursor: "pointer",
    },
  },
  link: {
    color: "white",

    "&:hover": {
      backgroundColor: theme.palette.secondary.dark,
      cursor: "pointer",
      color: "white",
    },
  },
  inputNuevaBanda: {
    width: "100%",
  },
}));

function TurnosHub() {
  const classes = useStyles();
  const [stepper, setStepper] = React.useState(false);
  const [permisos, setPermisos] = React.useState([]);
  const [loadingPermisos, setLoadingPermisos] = useState(true);
  const [keyLista, setKeyLista] = React.useState(0);
  const history = useHistory();

  useEffect(() => {
    consultarPermisos();
  }, []);
  const consultarPermisos = () => {
    const permissionConfig = {
      modulo: getPermisoDefinicion(PERMISOS.P_CONSULTAR_TURNOS_FILTRO)[
        "modulo"
      ],
      pantalla: getPermisoDefinicion(PERMISOS.P_CONSULTAR_TURNOS_FILTRO)[
        "pantalla"
      ],
      history: history,
      setLoadingPermisos: setLoadingPermisos,
      setAllowedAction: setPermisos,
    };

    new Permission(permissionConfig).applyPermission();
  };

  return (
    <>
      {loadingPermisos ? (
        <Backdrop className={classes.backdrop} open={true}>
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <Grid container spacing={4}>
          <Grid item md={9}>
            <Card style={{ height: 120, width: "100%" }}>
              <CardContent>
                <Typography variant="h5">Hub Turnos</Typography>
                {/* <Typography>Reservar, organizar, cancelar, ver turnos</Typography> */}
              </CardContent>
            </Card>
          </Grid>
          <Grid item md={3}>
            <Button
              className={classes.cardCrear}
              disabled={!permisos.includes("reserva")}
              variant="contained"
              color="secondary"
              onClick={() => history.push("/reservaTurnoInterno") }
            >
                Reservar
            </Button>
          </Grid>
          <TurnosLista drawer={setStepper} key={keyLista} permisos={permisos} />
        </Grid>
      )}
    </>
  );
}
export default TurnosHub;
